// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyFloorPlanCreateResponseV2WebDto,
  UserPropertyFloorPlanCreateV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create_Args {
  postData: UserPropertyFloorPlanCreateV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create_Options = UseMutationOptions<
  UserPropertyFloorPlanCreateResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create_Args
>;

/**
 * Create a floor plan for the property
 */
export const useRentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create_Args) =>
      RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create(args.postData, httpClient),
  });
};
